'use client';
import { usePrivy } from '@privy-io/react-auth';
import { useCurrentPrivyWallet } from './useCurrentPrivyWallet';
import { clearSession } from '@/db/queries';
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { Hex } from 'viem';
import { db } from '@/db/db';
import { LATEST_DOC_ID, LS_ENS_MAP } from '@/utils/constants';
import { useAccountName } from '@/components/providers/account-name-provider';

export const useLogout = () => {
  const { logout } = usePrivy();
  const { currentWallet, authenticated } = useCurrentPrivyWallet();
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const { resetAccountName } = useAccountName();

  const onLogout = async (clearIdbData: boolean = true) => {
    if (!currentWallet) return;
    try {
      setLoading(true);
      authenticated && (await logout());
      await clearSession(currentWallet.address as Hex);
      if (clearIdbData) {
        await db.ddocs.clear();
      }
      localStorage.removeItem(LATEST_DOC_ID);
      localStorage.removeItem(LS_ENS_MAP);
      resetAccountName();
      router.replace('/document/create');
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return { onLogout, isLoading: loading };
};
